import styled from "@emotion/styled/macro";
import React, { Fragment } from "react";

import { Spacer } from "Components/Common/Spacer/index";
import {
  FlexWrapperT2,
  FlexWrapperT4,
  FlexWrapperT6,
} from "Components/Common/Wrapper/FlexWrapper";
import {
  TypographyT13,
  TypographyT17,
  TypographyT33,
  TypographyT34,
} from "Components/Common/Typography/index";
import RateInfoCard from "./RateInfoCard";
import { Wrapper } from "Components/Common/Wrapper/index";
import { LabelT2 } from "Components/Common/Label/index";
import SelectT1 from "Components/Common/Select/SelectT1";
import Message from "Components/Common/Message/Message";
import { getToFixedValue } from "Utils/index";
import PaginationButtons from "./PaginationButtons";
const options = [
  { value: "Lucknow", label: "Lucknow" },
  { value: "All", label: "All" },
  { value: "Mundra", label: "Mundra" },
];
const FreightDetailsT1 = (props) => {
  const {
    viewDetailsRailFreightBcn = [],
    wagonTypes,
    wagonType,
    handleOnChangeWagonType,
    railRakeList,
    railRake,
    handleOnChangeRailRake,
    handleOnClickRAFRPreviousPage,
    handleOnClickRAFRNextPage
  } = props;

  const shouldRenderTable = () => {
    const C1 = viewDetailsRailFreightBcn.length > 0;
    if (C1) {
      return true;
    }
    return false;
  };
  return (
    <Fragment>
      <FreightDetailsWrapper>
        <FlexWrapperT2>
        <TypographyT33>RAIL FREIGHT BCN</TypographyT33>
            <PaginationButtons
                handleOnClickNextPage={handleOnClickRAFRNextPage}
                handleOnClickPreviousPage={handleOnClickRAFRPreviousPage}
              />
        </FlexWrapperT2>
        <Spacer spacing={"5px 0px"} />
        <FlexWrapperT6>
          {viewDetailsRailFreightBcn.length === 0 && <Message />}
          {shouldRenderTable() && (
            <TableWrapper>
              <Table>
                <THead>
                  <Tr>
                    {viewDetailsRailFreightBcn.map((ele, ind) => {
                      return (
                        <Fragment key={ind}>
                          <Th>
                            <TypographyT13>{`${ele.from} - ${ele.origin_yard} - ${ele.destination_yard} - ${ele.to}`}</TypographyT13>
                          </Th>
                        </Fragment>
                      );
                    })}
                  </Tr>
                </THead>
                <TBody>
                  <Tr>
                    {viewDetailsRailFreightBcn.map((ele, ind) => {
                      return (
                        <Fragment key={ind}>
                          <RateInfoCardT1
                            isActive={false}
                            isLActive={ele.rate_order_text === "L1"}
                            rate={getToFixedValue(ele.sum_of_bid_price,2)}
                            labelOfL={ele.rate_order_text}
                            // labelOne={`TAT - `}
                            // labelOne={`TAT - ${ele.tat.value} ${ele.tat.name}`}
                          />
                        </Fragment>
                      );
                    })}
                  </Tr>
                </TBody>
              </Table>
            </TableWrapper>
          )}
          {/* <Wrapper>
            <Wrapper>
              <LabelT2>Rake Type</LabelT2>
              <Spacer spacing={"1px"} />
              <SelectT1
                isClearable={true}
                options={railRakeList}
                value={railRake}
                onChange={handleOnChangeRailRake}
              />
            </Wrapper>
            <Wrapper>
              <LabelT2>Wagon Weight</LabelT2>
              <Spacer spacing={"1px"} />
              <SelectT1
                isClearable={true}
                options={wagonTypes}
                value={wagonType}
                onChange={handleOnChangeWagonType}
              />
            </Wrapper>
          </Wrapper> */}
        </FlexWrapperT6>
      </FreightDetailsWrapper>
    </Fragment>
  );
};

export default FreightDetailsT1;

const RateInfoCardT1 = (props) => {
  const {
    isActive,
    isLActive,
    labelOfL,
    rate,
    labelOne,
    labelTwo,
    showRateVariation,
  } = props;
  return (
    <Fragment>
      <Td bgColor={!!isActive && "#4E9757"}>
        <RateInfoCard
          rate={rate}
          labelOfL={labelOfL}
          isActive={!!isActive}
          isLActive={isLActive}
          showRateVariation={showRateVariation}
        />
        <Spacer spacing={"3px 0px"} />
        <FlexWrapperT4>
          {!!labelOne && <TypographyT34>{labelOne}</TypographyT34>}
          {!!labelTwo && <TypographyT34>{labelTwo}</TypographyT34>}
        </FlexWrapperT4>
      </Td>
    </Fragment>
  );
};

const FreightDetailsWrapper = styled.div``;

const TableWrapper = styled.div`
  overflow: auto;
  // width: calc(100% - 150px);
  width: 100%;
`;

const Table = styled("table")`
  width: 100%;
  border-spacing: 0px;
  border-radius: 3px;
  box-shadow: 0px 0px 2px 1px #d1d1d1;
`;

const Th = styled("th")`
  padding: 10px;
  background-color: #d4e2fa;
  text-align: left;
  border-top: 1px solid #677586;
  border-bottom: 1px solid #677586;
  border-right: 1px solid #677586;
`;

const THead = styled("thead")`
  & ${Th}:last-of-type {
    border-top-right-radius: 3px;
  }
  & ${Th}:first-of-type {
    border-top-left-radius: 3px;
    border-left: 1px solid #677586;
  }
`;
const TBody = styled("tbody")``;
const Td = styled("td")`
  padding: 10px;
  background-color: ${({ bgColor }) => (!!bgColor ? bgColor : "#f6f9ff")};
  border-bottom: 1px solid rgba(82, 138, 234, 0.45);
  border-bottom: 1px solid #677586;
  border-right: 1px solid #677586;
`;
const Tr = styled("tr")`
  & ${Td}:last-of-type {
    border-bottom-right-radius: 3px;
  }
  & ${Td}:first-of-type {
    border-bottom-left-radius: 3px;
    border-left: 1px solid #677586;
  }
`;
